import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import refs from '../helpers/refs'

class CCartMenu {
  constructor (el) {
    this.component = el
    this.$refs = refs(this.component)
    this.init()
  }

  init () {
    document.addEventListener('masterbuilt:open-cart-menu', (e) => {
      this.openMenu()
    })

    this.$refs.overlay.addEventListener('click', () => {
      this.closeMenu()
    })

    this.$refs.close.addEventListener('click', (e) => {
      e.preventDefault()
      this.closeMenu()
    })
  }

  openMenu () {
    this.component.classList.add('c-cart-menu--open')
    disableBodyScroll(this.component)
  }

  closeMenu () {
    this.component.classList.remove('c-cart-menu--open')
    enableBodyScroll(this.component)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-c-cart-menu]')
    .forEach(el => new CCartMenu(el))
})
